// extracted by mini-css-extract-plugin
export var label = "_7v-1";
export var reminder = "_7v-0";